<template>
    <div>
        <h3>{{ question.number }}. {{ question.question }}</h3>
        <Options :question="question.id" :options="question.options" :answer="answer" />
    </div>
</template>

<script>
import Options from "@/components/Options";

export default {
    props: ["question", "answers"],
    computed: {
        answer() {
            let res = this.answers.find((ans) => {
                return ans.question == this.question.id;
            });

            if (res) {
                return res.answer;
            }

            return null;
        },
    },
    components: {
        Options,
    },
};
</script>

<style>
</style>
